import React, { Component } from 'react';
import { List, Row, Col } from 'antd';
import './index.css'
import '../../assets/css/common.css'
import { searchAPI } from '../../api/tool.js'
import MyBreadcrumb from '../../components/MyBreadcrumb.jsx'

class Tool extends Component {
	constructor(props) {
		super(props);
		this.state = {
			total: 0,
			pageSize: 10,
			pageNum: 1,
			dataSource: [],
			loading: false,
		}
	}

	componentDidMount() {
		this.fetchData()
	}

	fetchData = () => {
		const { pageSize, pageNum } = this.state;
		this.setState({ loading: true }, () => {
			searchAPI({ page_size: pageSize, page_num: pageNum })
				.then(res => {
					this.setState({
						dataSource: res.data.data.data,
						total: res.data.data.total,
						loading: false,
					})
				})
			document.body.scrollTop = 0; // For Safari
			document.documentElement.scrollTop = 0;
		})
	}

	handlePageSizeChange = (current, pageSize) => {
		this.setState({ pageSize: pageSize, pageNum: current }, () => {
			this.fetchData()
		})
	}

	handlePageNumChange = (pageNum) => {
		this.setState({ pageNum }, () => {
			this.fetchData()
		})
	}

	render() {
		const { dataSource, total, loading } = this.state;
		return (
			<div style={{ margin: '40px 15%', }}>

				<MyBreadcrumb urls={[
					{ url: '/tool', breadcrumbName: '工具' },
				]} />
				<div className="major-heading module-title" style={{ textAlign: 'left', marginTop: 10, color: '#144db9' }}>工具</div>
				<div className="auxiliary-text module-subtitle">TOOL</div>
				<List dataSource={dataSource}
					className="list-res"
					bordered size="large"
					locale={{ emptyText: ' ' }} loading={{ tip: "数据加载中 ...", spinning: loading }}
					renderItem={(item, index) => (
						<div>
							<Row className="list" style={{ marginTop: 14, color: item.is_top ? 'red' : '#333333' }}>
								<Col span={23} className="main-text" style={{ marginLeft: -10, fontSize: 16 }}>
									<ul>
										<li>
											<a target="_blank" href={item.url} style={{ color: '#333333' }}>{item.title}</a>
										</li>
									</ul>
								</Col>
							</Row>

							<Row>
								<Col span={23} className="main-text" style={{ marginLeft: 30, color: '#999999', fontSize: 14 }}>
									{item.info}
								</Col>
							</Row>

							<Row>
								<Col span={23} className="auxiliary-text" style={{ marginLeft: 30, color: '#999999' }}>
									{item.developers}
								</Col>
							</Row>
						</div>
					)}
					style={{ marginTop: 10, marginLeft: 10, }}
					pagination={{ showQuickJumper: true, total: total, onChange: this.handlePageNumChange, onShowSizeChange: this.handlePageSizeChange, showSizeChanger: true, }}
				/>
			</div>
		);
	}
}

export default Tool
